<template>
  <div class="container-fluid py-4 px-4">
    <div class="row no-gutters text-left">
      <div class="col-12 col-md-auto">
        <h4 class="font-weight-bold">Dashboard</h4>
      </div>
      <div class="col-12">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'index',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>

</style>
